
document.addEventListener('DOMContentLoaded', () => {
    if (window.customSizeManagerInitialized) return;
    window.customSizeManagerInitialized = true;

    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (node.nodeType === 1) {
                    // Check if the added node is a variant-picker
                    if (node.tagName === 'VARIANT-PICKER') {
                        initCustomSizeInstance(node);
                    }
                    // Check if the added node contains a variant-picker (e.g. the modal content wrapper)
                    else if (node.querySelectorAll) {
                        const pickers = node.querySelectorAll('variant-picker');
                        pickers.forEach(picker => initCustomSizeInstance(picker));
                    }
                }
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Initialize existing pickers
    document.querySelectorAll('variant-picker').forEach(picker => initCustomSizeInstance(picker));
});

function initCustomSizeInstance(variantPicker) {
    if (variantPicker.dataset.customSizeInitialized) return;

    // Robust container finding
    let container = null;

    // 1. Try previous element sibling (ignoring scripts/text)
    let prev = variantPicker.previousElementSibling;
    while (prev && (prev.tagName === 'SCRIPT' || prev.nodeType === 3)) {
        prev = prev.previousElementSibling;
    }
    if (prev && prev.classList.contains('custom-size-container')) {
        container = prev;
    }

    // 2. Try searching in the parent element
    if (!container && variantPicker.parentElement) {
        container = variantPicker.parentElement.querySelector('.custom-size-container');
    }

    // 3. Try searching in the closest product-details wrapper
    if (!container) {
        const wrapper = variantPicker.closest('.product-details') || variantPicker.closest('.quick-add-modal__content');
        if (wrapper) {
            container = wrapper.querySelector('.custom-size-container');
        }
    }

    if (!container) return; // No custom size form found for this picker

    variantPicker.dataset.customSizeInitialized = 'true';

    const topInputsEl = container.querySelector('.custom-size-inputs-top');
    const bottomInputsEl = container.querySelector('.custom-size-inputs-bottom');
    let productForm = null;

    // Robust form finding
    // 1. Try closest form
    productForm = variantPicker.closest('form');

    // 2. Try finding form in parent container
    if (!productForm) {
        const parentContainer = variantPicker.closest('.product-details') || variantPicker.parentElement || variantPicker.closest('.quick-add-modal__content');
        if (parentContainer) {
            productForm = parentContainer.querySelector('form[action*="/cart/add"]');
        }
    }

    // 3. Fallback for form finding (generic ID)
    if (!productForm && variantPicker.dataset.sectionId) {
        productForm = document.getElementById(`BuyButtons-ProductForm-${variantPicker.dataset.sectionId}`);
    }

    function insertInputs() {
        const fieldsets = variantPicker.querySelectorAll('fieldset, .product-form__input');

        fieldsets.forEach((fieldset, index) => {
            const legend = fieldset.querySelector('legend, .form__label');
            const labelText = legend ? legend.textContent.toLowerCase() : '';

            let isTop = labelText.includes('top') || labelText.includes('kurta') || labelText.includes('upper') || index === 0;
            let isBottom = labelText.includes('bottom') || labelText.includes('pant') || labelText.includes('lower');

            if (isTop && isBottom) {
                if (index === 0) isBottom = false;
                else isTop = false;
            } else if (!isTop && !isBottom) {
                if (index === 0) isTop = true;
                else if (index === 1) isBottom = true;
            }

            if (isTop && topInputsEl) {
                if (topInputsEl.previousElementSibling !== fieldset) {
                    fieldset.after(topInputsEl);
                }
            } else if (isBottom && bottomInputsEl) {
                if (bottomInputsEl.previousElementSibling !== fieldset) {
                    fieldset.after(bottomInputsEl);
                }
            }
        });
    }

    function updateVisibility() {
        let showTop = false;
        let showBottom = false;

        const fieldsets = variantPicker.querySelectorAll('fieldset, .product-form__input');

        fieldsets.forEach((fieldset, index) => {
            const legend = fieldset.querySelector('legend, .form__label');
            const labelText = legend ? legend.textContent.toLowerCase() : '';

            let isTop = labelText.includes('top') || labelText.includes('kurta') || labelText.includes('upper') || index === 0;
            let isBottom = labelText.includes('bottom') || labelText.includes('pant') || labelText.includes('lower');

            if (isTop && isBottom) {
                if (index === 0) isBottom = false;
                else isTop = false;
            } else if (!isTop && !isBottom) {
                if (index === 0) isTop = true;
                else if (index === 1) isBottom = true;
            }

            const checkedInput = fieldset.querySelector('input[type="radio"]:checked, option:checked');
            if (checkedInput) {
                const val = (checkedInput.value || checkedInput.textContent).trim().toLowerCase();
                if (val === 'custom' || val === 'custom size') {
                    if (isTop) showTop = true;
                    if (isBottom) showBottom = true;
                }
            } else {
                const select = fieldset.querySelector('select');
                if (select) {
                    const val = select.value.trim().toLowerCase();
                    if (val === 'custom' || val === 'custom size') {
                        if (isTop) showTop = true;
                        if (isBottom) showBottom = true;
                    }
                }
            }
        });

        if (topInputsEl) {
            if (showTop) {
                topInputsEl.style.display = 'block';
                topInputsEl.querySelectorAll('input').forEach(i => i.disabled = false);
            } else {
                topInputsEl.style.display = 'none';
                topInputsEl.querySelectorAll('input').forEach(i => i.disabled = true);
            }
        }

        if (bottomInputsEl) {
            if (showBottom) {
                bottomInputsEl.style.display = 'block';
                bottomInputsEl.querySelectorAll('input').forEach(i => i.disabled = false);
            } else {
                bottomInputsEl.style.display = 'none';
                bottomInputsEl.querySelectorAll('input').forEach(i => i.disabled = true);
            }
        }
    }

    function checkValidation(e) {
        // 0. Check the event target/submitter directly.
        const target = e.target;
        const submitter = e.submitter;

        // If we are in Quick Add, we still want to validate now (per user request)
        // So we removed the bypass logic.

        if ((topInputsEl && topInputsEl.style.display !== 'none') || (bottomInputsEl && bottomInputsEl.style.display !== 'none')) {
            let allFilled = true;
            if (topInputsEl && topInputsEl.style.display !== 'none') {
                topInputsEl.querySelectorAll('input').forEach(input => {
                    if (!input.value || input.value.trim() === '') allFilled = false;
                });
            }
            if (bottomInputsEl && bottomInputsEl.style.display !== 'none') {
                bottomInputsEl.querySelectorAll('input').forEach(input => {
                    if (!input.value || input.value.trim() === '') allFilled = false;
                });
            }

            if (!allFilled) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                if (topInputsEl && topInputsEl.style.display !== 'none') {
                    const errorMsg = topInputsEl.querySelector('.custom-size-error-msg');
                    if (errorMsg) {
                        errorMsg.textContent = "Please fill all fields";
                        errorMsg.style.display = 'block';
                    }
                }
                if (bottomInputsEl && bottomInputsEl.style.display !== 'none') {
                    const errorMsg = bottomInputsEl.querySelector('.custom-size-error-msg');
                    if (errorMsg) {
                        errorMsg.textContent = "Please fill all fields";
                        errorMsg.style.display = 'block';
                    }
                }

                const firstError = document.querySelector('.custom-size-error-msg[style*="block"]');
                if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return false;
            }
        }
        return true;
    }

    // Initial setup
    insertInputs();
    updateVisibility();

    // Observer for re-renders of the variant picker itself (if it changes its children)
    const childObserver = new MutationObserver((mutations) => {
        let needsReinsert = false;
        for (const mutation of mutations) {
            if (mutation.type === 'childList') {
                if ((topInputsEl && !variantPicker.contains(topInputsEl)) || (bottomInputsEl && !variantPicker.contains(bottomInputsEl))) {
                    needsReinsert = true;
                    break;
                }
            }
        }

        if (needsReinsert) {
            insertInputs();
            updateVisibility();
        }
    });
    childObserver.observe(variantPicker, { childList: true, subtree: true });

    variantPicker.addEventListener('change', () => {
        updateVisibility();
    });

    if (productForm) {
        productForm.addEventListener('submit', checkValidation);
        const buttonContainer = productForm.querySelector('.product-form-buttons');
        if (buttonContainer) {
            // Listen for both click and touchend for mobile robustness
            const handleValidation = function (e) {
                if (e.target.closest('button') || e.target.closest('.shopify-payment-button__button')) {
                    checkValidation(e);
                }
            };
            buttonContainer.addEventListener('click', handleValidation, true);
            buttonContainer.addEventListener('touchend', handleValidation, true);
        }
    }
}

// Helper functions attached to window for the inline buttons
window.saveMeasurements = function (btn) {
    const inputContainer = btn.closest('div[class^="custom-size-inputs-"]');
    const successMsg = inputContainer.querySelector('.custom-size-success-msg');
    const errorMsg = inputContainer.querySelector('.custom-size-error-msg');

    let valid = true;
    inputContainer.querySelectorAll('input').forEach(input => {
        if (!input.value || input.value.trim() === '') valid = false;
    });

    if (valid) {
        if (successMsg) {
            successMsg.textContent = "Measurements saved! Proceed to Add to Cart.";
            successMsg.style.display = 'block';
        }
        if (errorMsg) errorMsg.style.display = 'none';
    } else {
        if (errorMsg) errorMsg.style.display = 'block';
        if (successMsg) successMsg.style.display = 'none';
    }
};

window.cancelCustomSize = function (btn, type) {
    const picker = btn.closest('variant-picker');
    if (picker) {
        const fieldsets = picker.querySelectorAll('fieldset, .product-form__input');
        fieldsets.forEach((fieldset, index) => {
            const legend = fieldset.querySelector('legend, .form__label');
            const labelText = legend ? legend.textContent.toLowerCase() : '';

            let isTop = labelText.includes('top') || labelText.includes('kurta') || labelText.includes('upper') || index === 0;
            let isBottom = labelText.includes('bottom') || labelText.includes('pant') || labelText.includes('lower');

            if (isTop && isBottom) {
                if (index === 0) isBottom = false;
                else isTop = false;
            } else if (!isTop && !isBottom) {
                if (index === 0) isTop = true;
                else if (index === 1) isBottom = true;
            }

            if ((type === 'top' && isTop) || (type === 'bottom' && isBottom)) {
                const checked = fieldset.querySelector('input:checked, option:checked');
                if (checked) {
                    const val = (checked.value || checked.textContent).trim().toLowerCase();
                    if (val === 'custom' || val === 'custom size') {
                        const siblings = fieldset.querySelectorAll('input[type="radio"], option');
                        for (let i = 0; i < siblings.length; i++) {
                            const sibVal = (siblings[i].value || siblings[i].textContent).trim().toLowerCase();
                            if (sibVal !== 'custom' && sibVal !== 'custom size') {
                                if (siblings[i].tagName === 'OPTION') {
                                    const select = siblings[i].closest('select');
                                    select.value = siblings[i].value;
                                    select.dispatchEvent(new Event('change', { bubbles: true }));
                                } else {
                                    siblings[i].click();
                                }
                                break;
                            }
                        }
                    }
                }
            }
        });
    }
};
